import { useFormContext } from 'react-hook-form'
import { Trans, useTranslation } from 'react-i18next'

import * as styles from './AgreementForm.module.scss'

import { usePropertyProvider } from '../../../hooks'
import { Agreement } from '../../../schemas'
import { FormCheckbox } from '../../basics'

const DEFAULT_TERM_URL = 'https://www.hkdballpark.com/terms/'
const T11_CLUB_LOUNGE_TERM_URL =
  'https://data.hkdballpark.com/private/pdfs/tower_eleven_club_lounge_terms.pdf'

export const AgreementForm = () => {
  const { t } = useTranslation()
  const { control } = useFormContext<Agreement>()
  const { isActivity, slug } = usePropertyProvider()

  const termUrl =
    slug === 'tower11_club_lounge' ? T11_CLUB_LOUNGE_TERM_URL : DEFAULT_TERM_URL

  const links = isActivity ? (
    <Trans
      i18nKey="components.AgreementForm.agreementWithGame"
      t={t}
      components={{
        term: (
          <a // eslint-disable-line jsx-a11y/anchor-has-content
            href={termUrl}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="term"
          />
        ),
        personal: (
          <a // eslint-disable-line jsx-a11y/anchor-has-content
            href="https://www.fighters.co.jp/company/privacy/"
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="privacy policy"
          />
        ),
        game: (
          <a // eslint-disable-line jsx-a11y/anchor-has-content
            href="https://www.fighters.co.jp/gamelive/agreement/"
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="privacy policy"
          />
        ),
      }}
    />
  ) : (
    <Trans
      i18nKey="components.AgreementForm.agreement"
      t={t}
      components={{
        term: (
          <a // eslint-disable-line jsx-a11y/anchor-has-content
            href={termUrl}
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="term"
          />
        ),
        personal: (
          <a // eslint-disable-line jsx-a11y/anchor-has-content
            href="https://www.fighters.co.jp/company/privacy/"
            className={styles.link}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="privacy policy"
          />
        ),
      }}
    />
  )
  return <FormCheckbox control={control} name="agreement" label={links} />
}
